import { ArticleDetail, ArticleListResult } from "../components/article/types";

export const API_BASE = (process.env.REACT_APP_API_URL_STAGE || "").trim();

export const getHeaders = () => {
  const credentials = btoa("Dive:Dive@123");
  return {
    Authorization: `Basic ${credentials}`,
    "Content-Type": "application/json",
    deviceid: "1234567890",
  };
};

export const fetchArticleDetail = async (
  articleId: string
): Promise<ArticleDetail> => {
  const response = await fetch(
    `${API_BASE}/api/v1/user/articles/detail?articleId=${articleId}`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );
  const json = await response.json();
  if (json.code !== 200 || !json.data) {
    throw new Error(json.message || "Failed to load article");
  }
  return json.data;
};

export const fetchArticleList = async (
  page = 1,
  limit = 5
): Promise<ArticleListResult> => {
  const response = await fetch(
    `${API_BASE}/api/v1/user/articles?pageNo=${page}&limit=${limit}`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );
  const json = await response.json();
  if (json.code !== 200) {
    throw new Error(json.message || "Failed to load articles");
  }
  return {
    articles: json.data?.data || [],
    nextHit: Boolean(json.data?.nextHit),
    pageNo: json.data?.pageNo || page,
  };
};
